import React from 'react'
import './MintButton.css'

const MintButton = () => {

	return (
		<div className="mint-ctn" onClick={() => {}}>
           + Mint New NFT Link
		</div>
	)
}

export default MintButton

